import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Avatar from '@deprecated-ui/common/Avatar';
import { PopoverContent } from '@deprecated-ui/common/Popover';
import { PopoverContainer } from '@deprecated-ui/header';
import color from '@deprecated-ui/_style/color';

const PopoverWeb = styled.div`
  & .ant-popover-content {
    border-radius: 6px !important;
    border: 1px solid ${color.gainsboro};

    .ant-popover-inner {
      border-radius: 6px;
    }
  }

`;

const CustomPopoverContainer = styled(PopoverContainer)`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  border: none;
  overflow-y: auto;
  background: ${color.light};
`;

const PopoverContentMobile = styled(PopoverContent)`
  /* border-bottom: 1px solid ${color.gainsboro}; */
`;

const MessageListContainer = styled(Flex).attrs((props) => ({
  align: 'center',
  padding: '10px 20px',
  isNew: props.isNew,
}))`
  height: 65px;
  cursor: pointer;
  :hover {
    background: ${color.downgray};
  }

  a {
    color: ${color.black};
  }
`;

const UnreadMessage = styled(Text).attrs({
  color: color.light,
  weight: '500',
  size: '11px',
  align: 'center',
  padding: '3px 2px',
})`
  background-color: ${color.primary};
  border-radius: 10px;
  min-width: 19px;
`;

const PopoverWrapperWeb = styled.div`
  border-radius: 6px;
  height: 100%;
`;

const PopoverContentWeb = styled(PopoverContent)`
  max-height: 325px;
  height: auto;
`;

const RoomItemStatus = styled(Flex).attrs({
  align: 'center',
})`
  img {
    width: 16px;
  }
  & > :last-child {
    margin-left: 5px;
  }
`;

const GroupAvatar = styled.span`
  width: 40px;
  height: 40px;
  line-height: 40px;
  display: block;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  border-radius: 100%;
  overflow: hidden;
  background: #ebf8f3;
  color: #00ab6b;
  i {
    font-style: normal;
  }
`;

const AvatarContainer = styled(Avatar)`
  padding-right: 12px;

  & > img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    border: 1px solid ${color.component};
    background: ${color.lowgray};
  }
`;

const MessageItemBody = styled.div`
  width: calc(100% - 52px);
`;

const MessageItemContent = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  display: flex;
  justify-content: 'space-between';
  align-items: 'center';
  flex-grow:1;
  
  p > img {
    margin-right: 5px;
  }
`;

const MessageCount = styled.span`
  display: block;
  position: absolute;
  top: 5%;
  left: 5%;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 2px;
  background-color: ${color.primary};
  border-radius: 10px;
  font-size: 11px;
  color: ${color.light};
  text-align: center;
  border: 1px solid #8f8f8f;
`;

const PopoverFooter = styled(Text).attrs({
  as: 'a',
  color: color.primary,
  align: 'center',
  family: 'bold',
})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color.light};
  padding: 20px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export {
  CustomPopoverContainer,
  MessageListContainer,
  PopoverContentMobile,
  UnreadMessage,
  PopoverContentWeb,
  PopoverWrapperWeb,
  RoomItemStatus,
  AvatarContainer,
  GroupAvatar,
  MessageItemBody,
  MessageItemContent,
  MessageCount,
  PopoverFooter,
  PopoverWeb,
};
